import React from 'react'
import styled from 'styled-components'

import {
  Box,
  Paragraph,
  ProgressIndicator,
  H1,
} from '@allied-solutions/affinity'

import {
  useMustAttachLogic,
  useSubmitInsuranceLogic,
  useAllowedFileTypes,
  insuranceTypes
} from '../../../hooks'
import {
  AppLayout,
  BackButton,
  ButtonGroup,
  NextButton,
  SubmitInsuranceLayout,
  UploadRightSide,
} from '../../../components'

const StyledButtonGroup = styled(ButtonGroup)`
  flex-direction: row;
  gap: ${props => props.theme.space[6]};

  & > button:last-child {
    margin-bottom: 0;
  }
`

const UploadDocuments = ({ location }) => {
  const { pages } = useSubmitInsuranceLogic(location)
  const acceptedTypes = useAllowedFileTypes(insuranceTypes.OTHER)

  const { handleSubmit, isValid } = useMustAttachLogic(location)

  return (
    <SubmitInsuranceLayout>
      <form onSubmit={handleSubmit}>
        <AppLayout
          leftSide={
            <>
              <Paragraph
                mb={6}
                typeStyle="labelLarge"
                textAlign="left"
                color="gray600"
              >
                Upload Files
              </Paragraph>
              <H1 typeStyle="headlineMedium" fontWeight={900}>
                We need to confirm you have proper coverage.
              </H1>
              <Paragraph
                typeStyle="bodyMedium"
                textAlign="left"
                color="gray600"
              >
                We help your lender confirm you have the right insurance
                coverage. All we need is copy of your insurance policy
                documents. Simply upload them here.
              </Paragraph>
            </>
          }
          rightSide={
            <UploadRightSide acceptedTypes={acceptedTypes} isValid={isValid} isOptional={false} />
          }
          footerButtons={
            <Box
              display="flex"
              alignItems="baseline"
              justifyContent="flex-end"
              gap={8}
            >
              <ProgressIndicator
                pages={pages}
                currentPage={location.pathname}
              />
              <StyledButtonGroup display="flex" justifyContent={[null, null, null, 'flex-end']}>
                <BackButton />
                <NextButton
                  // spoof Formik props
                  formikProps={{
                    isSubmitting: false,
                    isValid,
                  }}
                />
              </StyledButtonGroup>
            </Box>
          }
        />
      </form>
    </SubmitInsuranceLayout>
  )
}

export default UploadDocuments
